//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () {
    return {
      tabType: 'week',
      list: [],
      meta: {},
      pageNum: 1,
      pageSize: 20,
      hasMore: false,
      loading: false
    }
  },
  computed: {
    activeText () {
      const n = this.meta.active_users || 0
      return n > 0 ? `🔥 ${n} 位同学正在挑战` : '一起来打卡吧'
    }
  },
  created () {
    this.reload()
  },
  methods: {
    onTabChange () {
      this.reload()
    },
    reload () {
      this.pageNum = 1
      this.list = []
      this.fetch(true)
    },
    loadMore () {
      if (!this.hasMore || this.loading) return
      this.pageNum++
      this.fetch(false)
    },
    fetch (reset) {
      this.loading = true
      const url = newApi.checkinRanking + '?type=' + this.tabType + '&page_num=' + this.pageNum + '&page_size=' + this.pageSize
      this.$ajax.get(url).then(res => {
        const rows = (res && res.list) || []
        this.meta = res || {}
        this.list = reset ? rows : this.list.concat(rows)
        this.hasMore = !!(res && res.has_more)
      }).catch(() => {
        this.toast('加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    toast (msg) {
      if (this.$vux) this.$vux.toast.text(msg)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/checkin/ranking.vue